import { createFileRoute } from "@tanstack/react-router";
import { EsPlaceholder, esHead } from "@/knowmeno/marketing/EsPlaceholder";

export const Route = createFileRoute("/es/guia-menopausia")({
  head: () => esHead({
    path: "/guia-menopausia",
    title: "Guía de menopausia | SepaMeno",
    description: "Guía completa de menopausia en español: etapas, síntomas, tratamientos y respuestas a tus preguntas.",
    englishPath: "/menopause-guide",
  }),
  component: () => (
    <EsPlaceholder
      title="Guía de menopausia"
      subtitle="Estamos traduciendo nuestra guía completa al español, con revisión médica. Próximamente."
      englishHref="https://knowmeno.com/menopause-guide"
    />
  ),
});
